theme.headerMainMenuModule = (function () {
  var MEGA_CLOSE_MS = 420;
  function prefersReducedMotion() {
    try {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    } catch (e) {
      return false;
    }
  }
  function mainMenu() {
    let menuLiSelector = document.querySelectorAll(".header__menu_li");
    menuLiSelector.forEach((item) => {
      if (item.classList.contains("menu__item_has_children")) {
        let menuItemUrl = "",
          menuItemLocation = "";
        item.addEventListener("mouseover", (event) => {
          let listDetails = item.querySelector("details");
          var mega = item.querySelector(".header__mega_menu.mega__menu--wrapper");
          if (mega) mega.classList.remove("mega-menu--is-closing");
          listDetails.setAttribute("open", "");
          item.querySelector("summary").setAttribute("aria-expanded", true);
        });
        item.addEventListener("mouseleave", (event) => {
          let listDetails = item.querySelector("details");
          var summary = item.querySelector("summary");
          var mega = item.querySelector(".header__mega_menu.mega__menu--wrapper");
          if (
            mega &&
            listDetails.hasAttribute("open") &&
            !prefersReducedMotion()
          ) {
            var done = false;
            var fallbackId = null;
            function finishClose() {
              if (done) return;
              done = true;
              if (fallbackId != null) window.clearTimeout(fallbackId);
              mega.removeEventListener("transitionend", onEnd);
              mega.classList.remove("mega-menu--is-closing");
              listDetails.removeAttribute("open");
              if (summary) summary.setAttribute("aria-expanded", "false");
            }
            function onEnd(e) {
              if (e.target !== mega) return;
              var p = e.propertyName;
              if (p !== "opacity" && p !== "transform") return;
              finishClose();
            }
            mega.classList.add("mega-menu--is-closing");
            mega.addEventListener("transitionend", onEnd);
            fallbackId = window.setTimeout(finishClose, MEGA_CLOSE_MS);
          } else {
            if (mega) mega.classList.remove("mega-menu--is-closing");
            listDetails.removeAttribute("open");
            if (summary) summary.setAttribute("aria-expanded", "false");
          }
        });
        item.querySelector("summary").addEventListener("click", (event) => {
          event.stopPropagation();
          menuItemUrl = item.querySelector("summary").dataset.href;
          menuItemLocation = `${window.location.origin}${menuItemUrl}`;
          let itemAttr = item.querySelector("details");
          if (itemAttr.hasAttribute("open")) {
            location.href = `${menuItemLocation}`;
          }
        });
      }
    });
  }
  return mainMenu;
})();
